import React, { Component } from 'react';
import LocationForm from './LocationForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins } from '@fortawesome/free-solid-svg-icons';

class LocationItem extends Component {
    render() {
        if (!this.props.edit) {
            return (
                <div>
                    <h5>{this.props.location.title}</h5> <FontAwesomeIcon className="text-primary" size="sm" icon={faCoins} fixedWidth /> {this.props.location.dkp}
                    <p style={{marginBottom:'0px'}}>{this.props.location.description}</p>
                </div>
            )
        } else {
            return (
                <LocationForm form={this.props.location.slug + '-EditLocationForm'} editToggle={this.props.editToggle} onSubmit={this.props.onSubmit} initialValues={{title: this.props.location.title, description: this.props.location.description, dkp: this.props.location.dkp, slug: this.props.location.slug, chapter:this.props.chapter}} new={false} />
            )
        }
    }
}

export default LocationItem;


// WEBPACK FOOTER //
// ./src/Officer/LocationItem.js